import Phaser from 'phaser';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';

// Game configuration
const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    width: 360,
    height: 640,
    parent: 'game-container',
    backgroundColor: '#87CEEB', // Sky blue background
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { x: 0, y: 250 }, // Arcade-like gravity (lighter, more predictable)
            debug: false,
            fps: 60,
            timeScale: 1.0
        }
    },
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: 360,
        height: 640
    },
    scene: [GameScene, MenuScene],
    autoFocus: true
};

// Initialize the game only if the container exists and modal is open
let gameInstance: Phaser.Game | null = null;

function initGame() {
    const gameContainer = document.getElementById('game-container');
    const modal = document.getElementById('game-modal');
    
    // Only boot game if container exists and modal is open
    if (gameContainer && modal && modal.classList.contains('is-open') && !gameInstance) {
        gameInstance = new Phaser.Game(config);
    }
}

// Function to stop game music when modal closes
function stopGameMusic() {
    if (gameInstance) {
        const gameScene = gameInstance.scene.getScene('GameScene');
        if (gameScene && 'shutdown' in gameScene && typeof (gameScene as any).shutdown === 'function') {
            (gameScene as any).shutdown();
        }
    }
}

// Make stopGameMusic globally accessible
(window as any).stopGameMusic = stopGameMusic;

// Check on page load if #play is in URL
if (window.location.hash === '#play') {
    // Wait for modal to open
    setTimeout(() => {
        initGame();
    }, 200);
}

// Watch for modal opening
const modal = document.getElementById('game-modal');
if (modal) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const isOpen = modal.classList.contains('is-open');
                if (isOpen && !gameInstance) {
                    initGame();
                }
            }
        });
    });
    
    observer.observe(modal, {
        attributes: true,
        attributeFilter: ['class']
    });
}

